(function () {
  class AnnouncementPro extends HTMLElement {
    connectedCallback() {
      this.storageKey = 'announcement-dismissed-' + (this.dataset.sectionId || 'default');
      this.cooldownHours = parseFloat(this.dataset.cooldownHours || '24');

      if (this.isDismissed()) {
        this.classList.add('is-dismissed');
        return;
      }

      const closeBtn = this.querySelector('.announcement-pro__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.dismiss());
      }

      if (this.dataset.style === 'rotate') this.initRotation();
    }

    initRotation() {
      this.slides = Array.from(this.querySelectorAll('.announcement-pro__slide'));
      if (this.slides.length < 2) return;
      this.index = 0;
      this.autoplaySpeed = (parseFloat(this.dataset.rotateSpeed) || 5) * 1000;

      this.querySelectorAll('.announcement-pro__arrow--prev').forEach((btn) =>
        btn.addEventListener('click', () => this.goTo(this.index - 1, true))
      );
      this.querySelectorAll('.announcement-pro__arrow--next').forEach((btn) =>
        btn.addEventListener('click', () => this.goTo(this.index + 1, true))
      );

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(() => this.goTo(this.index + 1), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) clearInterval(this.timer);
    }

    goTo(newIndex, userTriggered) {
      this.slides[this.index].classList.remove('is-active');
      this.index = (newIndex + this.slides.length) % this.slides.length;
      this.slides[this.index].classList.add('is-active');
      if (userTriggered) this.startAutoplay();
    }

    isDismissed() {
      try {
        const ts = localStorage.getItem(this.storageKey);
        if (!ts) return false;
        return Date.now() - parseInt(ts, 10) < this.cooldownHours * 3600000;
      } catch (e) {
        return false;
      }
    }

    dismiss() {
      this.classList.add('is-dismissed');
      try {
        localStorage.setItem(this.storageKey, String(Date.now()));
      } catch (e) {
        /* storage unavailable */
      }
    }
  }

  if (!customElements.get('announcement-pro')) {
    customElements.define('announcement-pro', AnnouncementPro);
  }
})();
